module.exports = __webpack_public_path__ + "static/media/icon-fire.212cbd88.svg";